import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Space, Tag } from "antd";
import {
  ReadOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";

const { Text } = Typography;

export const TreinamentosRelatorioCompleto = () => {
  const { id_grupo, id_curso } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // DADOS
  const [curso, setCurso] = useState({});

  useEffect(() => {
    if (id_curso > 0) {
      carregarCurso(id_curso);
      listarRelatorio(id_curso);
    }
  }, [id_curso]);

  // LISTAR
  const listarRelatorio = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/relatorio_completo/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setDados(response);
    } else {
      navigate(`/treinamentos/grupos/cursos/${id_grupo}/relatorio/${id_curso}`);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setCurso(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const renderStatus = (status) => {
    if (status === 1) {
      return (
        <Tag icon={<CheckCircleOutlined />} color="green">
          Concluído
        </Tag>
      );
    } else if (status === 2) {
      return (
        <Tag icon={<ClockCircleOutlined />} color="processing">
          Em andamento
        </Tag>
      );
    } else if (status === 0) {
      return (
        <Tag icon={<CloseCircleOutlined />} color="default">
          Não Aprovado
        </Tag>
      );
    } else {
      return <Tag color="orange">Não iniciado</Tag>;
    }
  };

  const renderStatusText = (status) => {
    if (status === 1) {
      return "Concluído";
    } else if (status === 2) {
      return "Em andamento";
    } else if (status === 0) {
      return "Não Aprovado";
    }

    return "Não iniciado";
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Filial",
      dataIndex: "filial",
    },
    {
      title: "Colaborador",
      dataIndex: "colaborador",
    },
    {
      title: "Data Recebimento",
      dataIndex: "data_recebimento",
    },
    {
      title: "Nota",
      dataIndex: "media_obtida",
      renderText: (e) => e.media_obtida ?? "-",
      render: (_, e) => e.media_obtida ?? "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (_, e) => renderStatus(e?.status),
      renderText: (e) => renderStatusText(e?.status),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}/relatorio/${id_curso}`)}
            />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Relatório Completo"]}
              subtitle={
                <Text italic>
                  <ReadOutlined /> {curso?.descricao ?? ""}
                </Text>
              }
              icon={<BarChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <TableCustom loading={loading} columns={columns} dataSource={dados} />
              </Space>
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
